<template>
	<CommonEditor
		:config="config"
		:registeredList="displaySnackgameListWithMoment"
		:gameList="snackgameList"/>
</template>
<script>
import { mapGetters } from 'vuex'
import { MODULE_NAME as PGM_MODULE, FETCH_SNACKGAME_LIST } from '@/store/playGame/actions.type'
import { $showModalWithErrorMsg } from '@/common/util'
import { SHOW_MODAL } from '@/store/ui/mutations.type'
import CommonEditor from '@/views/PlayGame/components/CommonEditor.vue'
export default {
	components: {
		CommonEditor
	},
	data () {
		return {
			config: {
				type: 'playGameSnackgame',
				header: '스낵게임'
			}
		}
	},
	mounted () {
		this.$store.dispatch(PGM_MODULE + FETCH_SNACKGAME_LIST)
      .catch($showModalWithErrorMsg.bind(this))
	},
	computed: {
		...mapGetters(PGM_MODULE, [
			'snackgameList'
		]),
		...mapGetters(PGM_MODULE, [
			'displaySnackgameListWithMoment'
		]),
	},
}
</script>
